import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import {
    ExportProgressState,
    SaleOrderExportPollerService,
} from '../../services/sale-order-export-poller.service';

export interface ExportProgressDialogData {
    alreadyInProgress?: boolean;
}

@Component({
    selector: 'eci-export-progress-dialog',
    templateUrl: './export-progress-dialog.component.html',
    styleUrls: ['./export-progress-dialog.component.scss'],
})
export class ExportProgressDialogComponent implements OnDestroy {
    state: ExportProgressState = {
        jobId: null,
        status: 'idle',
        message: 'Export started. Your file will download when ready.',
        errorMessage: null,
        inProgress: false,
    };
    alreadyInProgress = false;
    private sub: Subscription;
    /** Ignore a leftover `ready` from a previous export when this dialog opens. */
    private sawActiveExport = false;

    constructor(
        private dialogRef: MatDialogRef<ExportProgressDialogComponent>,
        private poller: SaleOrderExportPollerService,
        @Inject(MAT_DIALOG_DATA) data: ExportProgressDialogData,
    ) {
        this.alreadyInProgress = !!data?.alreadyInProgress;
        this.sub = this.poller.state$.subscribe((state) => {
            this.state = state;
            if (state.status === 'pending' || state.status === 'processing') {
                this.sawActiveExport = true;
            }
            if (state.status === 'ready' && this.sawActiveExport) {
                // Give the browser a moment to start the download, then close
                setTimeout(() => {
                    if (this.dialogRef) {
                        this.dialogRef.close('ready');
                    }
                }, 800);
            }
        });
    }

    get showSpinner(): boolean {
        return this.state.status === 'pending'
            || this.state.status === 'processing'
            || this.state.status === 'ready';
    }

    get showCancelExport(): boolean {
        return this.state.status === 'pending' || this.state.status === 'processing';
    }

    get showClose(): boolean {
        return this.state.status === 'failed' || this.state.status === 'cancelled';
    }

    cancelExport(): void {
        this.poller.cancelCurrent().subscribe({
            next: () => this.dialogRef.close('cancelled'),
            error: () => this.dialogRef.close('cancelled'),
        });
    }

    close(): void {
        this.dialogRef.close('closed');
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
